// App color palette. Kept free of imports so type and translation modules can
// use it without pulling in React, Firebase or the rest of Helpers/utils.
const COLORS = {
    primary: '#3cb6df',
    primaryDark: '#369ec3',
    deepGreen: '#36c356',
    deepRed: '#c33636',
    primaryDarkHover: '#ffffff',
    purple: '#9636c3',
    secondary: '#555',
    background: '#f4f4f4',
    redOrange: '#fd795f',
    gold: '#c39836',
    yellow: '#f5c45f',
    mediumPriorityYellow: '#ffc107', // Matches Förvaltning medium priority tag (Bootstrap warning)
    inspectionPurple: '#b57ba6', // Matches Förvaltning "Kontroll" badge (.badge-inspection)
    text: '#000',
    highlight: '#e0f7fa',
    lightLightGrey: '#f7f6f7',
    lightGrey: '#EFEFEF',
    middleGrey: '#b3b3b3',
    breadcrumbBackground: '#001D60',
    brandDarkBlue: '#001D60',
    brandLightBlue: '#28aede',
    locationRed: '#FF5A34', // Component location markers (Marker, LocationPin, .location-display-marker)
};

export default COLORS;
